import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Box, Grid } from "@mui/material";
import FormikControl from "../../common/FormikControl";
import { LoadingButton } from "@mui/lab";
import { useEffect } from "react";
import { fetchLSMRejectionReason, selectAllLSMRejectionReason } from "../../../slices/common";
import BsModal from "../../common/BaseModal";
import { rejectedLSM, selectRejectedLSMLoading } from "../../../slices/logisticSlice";

const initialValues = {
    reason: "",
    comment: "",
};
const validationSchema = Yup.object().shape({
    reason: Yup.string().required("Reason is required"),
    comment: Yup.string()
        .when('reason', {
            is: (reason) => reason == 1,
            then: Yup.string()
                .required("Comment is required")
                .max(255, "Maximum of 255 characters"),
            otherwise: Yup.string().notRequired()
        })
});


const RejectLSM = ({ handleSubmitRejectLSM = () => { }, open, setOpen, qrCode_id, feasibility_assessments_id }) => {
    const dispatch = useDispatch();
    const allLSMRejectionReason = useSelector(selectAllLSMRejectionReason)
    const isLoading = useSelector(selectRejectedLSMLoading)
    const handleSubmit = async (values) => {
        try {
            const data = {
                id: feasibility_assessments_id,
                data: { ...values, reason: allLSMRejectionReason?.items?.find(op => op.id == values?.reason)?.name, qrCode_id: qrCode_id }
            }
            await dispatch(rejectedLSM(data))
            handleSubmitRejectLSM()
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        dispatch(fetchLSMRejectionReason())
    }, [open])

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleSubmit,
    });

    const formOptions = [
        {
            type: "select",
            label: "Select a reason to reject",
            name: "reason",
            options: allLSMRejectionReason?.items?.map(op => { return { value: op.id, label: op.name } }),
            required: true,
            placeholder: "Select reason",
        },
        ...(formik.values.reason == 1 ? [{
            label: "Comment",
            type: "textarea",
            name: "comment",
            required: true,
            placeholder: "Enter comment",
        }] : [])
    ];


    return (

        <BsModal
            fullWidth={true}
            open={open}
            onClose={() => setOpen(false)}
            title={"Reject LSM"}
        >
            <Box>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2} className="mb-3">
                        {formOptions.map((props, key) => (
                            <Grid key={key} item xs={12}>
                                <FormikControl formik={formik} {...props} />
                            </Grid>
                        ))}
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <LoadingButton loading={isLoading} fullWidth type="submit" variant="contained">
                                Submit
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </BsModal>
    );
};

export default RejectLSM;
